import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ChangeOfBasisModule = () => (
  <QPhototModuleSubtopic
    title="Change of Basis"
    videos={[]}
    takeaways={[
    
      {text:"We couldn't find the perfect videos for this topic. If you have found any, please send them through the feedback."},
      {text:"You can study this topic by referring to the provided notes."},
      {image:"/cvla_86.png"},
      {image:"/cvla_87.png"},
      {image:"/cvla_88.png"},
      
    ]}
    questions={[
      {image:"/cvla_89.png"},
      {image:"/cvla_90.png"},
      {image:"/cvla_91.png"},
      {image:"/cvla_92.png"},
      {image:"/cvla_93.png"},
    ]}
    exampleVideos={[]}
  />
);

export default ChangeOfBasisModule;
